import React, { useContext, useState } from 'react'
import Style from './Login.module.css'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { paths } from '../../utils/routes';
import { UserContext } from '../../context/userAuth';

export default function Login() {


  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('');
  const navigator = useNavigate()
  const { userTokne, setUserToken } = useContext(UserContext);
  const initialValues = {
    email: '',
    password: '',
  }

  const submitLogin = async (values) => {
    setIsLoading(true);
    try {
      const { data } = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/signin', values)
      if (data.message === 'success') {
        localStorage.setItem('userToken', data.token)
        setUserToken(data.token);
      }
      setIsLoading(false);
      navigator(paths.home);
    } catch (error) {
      setError('error');
      setIsLoading(false);
    }
  }

  const validationSchema = Yup.object({
    email: Yup.string().email('Email is Invalid').required('Email is Required'),
    password: Yup.string().required('Password is Required').min(8, 'Password must be more than 8 Chars').max(16, 'You Reached Maximum length'),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: submitLogin
  })
  return <>
    <div className="w-75 m-auto p-3">
      <h3 className='my-3'>Login</h3>
      {error && <p className='alert alert-danger'>{error}</p>}
      <form onSubmit={formik.handleSubmit}>
        <label htmlFor="email">Email</label>
        <input type="email" name="email" id="email" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.errors.email && formik.touched.email && <p className='alert alert-danger'> {formik.errors.email}</p>}
        <label htmlFor="password">Password</label>
        <input type="password" name="password" id="password" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.errors.password && formik.touched.password && <p className='alert alert-danger'>{formik.errors.password}</p>}
        <Link to={paths.forgetPassword} className='d-block cursor-pointer text-main '>Forgot Password?</Link>
        <button type='submit' className='bg-main btn text-white mt-2' disabled={!(formik.errors && formik.dirty)}>{isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Log In'}</button>
      </form>
    </div>
  </>
}